module.exports = __webpack_public_path__ + "static/media/note-6.b0b8e725.svg";